import React, { useRef } from "react";
import usePluginEntities from "hooks/usePluginEntities";
const usePluggableEventActions = (events, onlyBulk = false, onEventCallback) => {
  const modalRefs = useRef({});
  const pluggableActions = usePluginEntities("views.components.eventActions");
  const availableActions = pluggableActions.filter(
    (action) => (onlyBulk ? action.isBulk : true) && (action.useCondition ? !!action.useCondition(events) : true)
  );
  const actions = availableActions.map(
    ({
      component: PluggableEventAction,
      key
    }) => /* @__PURE__ */ React.createElement(
      PluggableEventAction,
      {
        key: `event-action-${key}`,
        events,
        modalRef: () => modalRefs.current[key],
        fromBulk: onlyBulk,
        onEventCallback
      }
    )
  );
  const actionModals = availableActions.filter(({ modal }) => !!modal).map(({ modal: ActionModal, key }) => /* @__PURE__ */ React.createElement(
    ActionModal,
    {
      key: `event-action-modal-${key}`,
      events,
      ref: (r) => {
        modalRefs.current[key] = r;
      },
      fromBulk: onlyBulk
    }
  ));
  return { actions, actionModals };
};
export default usePluggableEventActions;
